import { clearEmails, setEmails, setStoredEmails } from "../../../store/actions/emailActions";
import { authLogout } from "../../../store/actions/authActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import API from "../../../store/api";
import { SET_ADMIN_NOTIFICATIONS, CLEAR_ADMIN_NOTIFICATIONS, setAdminNotifications, clearAdminNotifications } from "../../../store/actions/notificationAdminActions";

export const getNotifications = (bearerAuth) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.get(`/api/portal/notification`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(setAdminNotifications(response.body))
        } else if (response.status === 401) {
          dispatch(clearAdminNotifications);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Get Notification Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}